export default "__VITE_ASSET__B4_oRAS8__"